import { InfoCircleOutlined } from '@ant-design/icons';
import { Checkbox, Col, Row, Select, Space, Switch, Tooltip } from 'antd';
import React from 'react';
import { NumberInput } from '../../NumberInput';

interface FilterRowProps {
  label: string;
  from: string;
  to: string;
  enabled: boolean;
  type?: "range" | "switch" | "min" | "select" | "checkbox-list";
  placeholders?: { from: string; to?: string };
  tooltip?: string;
  options?: Array<{ label: string; value: string | number }>;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  onToggle?: (value: boolean) => void;
}

const FilterRow: React.FC<FilterRowProps> = ({
  label,
  from,
  to,
  enabled,
  type = "range",
  placeholders,
  tooltip,
  options,
  onFromChange,
  onToChange,
  onToggle,
}) => {
  return (
    <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
      <Col span={6}>
        <span>
          {label}
          {tooltip && (
            <Tooltip
              title={tooltip}
              overlayStyle={{ maxWidth: '500px' }}
              overlayInnerStyle={{ whiteSpace: 'pre-line' }}
            >
              <InfoCircleOutlined
                style={{
                  color: '#1890ff',
                  cursor: 'help',
                  fontSize: '0.75em',
                  verticalAlign: 'super',
                  marginLeft: '4px'
                }}
              />
            </Tooltip>
          )}
        </span>
      </Col>
      <Col span={18}>
        {type === "switch" ? (
          <Switch checked={enabled} onChange={onToggle} />
        ) : type === "select" ? (
          <Space style={{ width: '100%' }}>
            <Select
              value={from || undefined}
              onChange={(value) => onFromChange(String(value))}
              style={{ flex: 1, minWidth: 0 }}
              options={options}
            />
            <div style={{ flex: 1 }} />
          </Space>
        ) : type === "checkbox-list" ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {options?.map((option) => {
              const selectedValues = from ? (() => {
                try {
                  return JSON.parse(from);
                } catch {
                  return [];
                }
              })() : [];
              const isChecked = selectedValues.includes(option.value);
              return (
                <div key={String(option.value)} style={{ width: '180px' }}>
                  <Checkbox
                    checked={isChecked}
                    onChange={(e) => {
                      const newValues = e.target.checked
                        ? [...selectedValues, option.value]
                        : selectedValues.filter((v: string | number) => v !== option.value);
                      onFromChange(JSON.stringify(newValues));
                    }}
                  >
                    {option.label}
                  </Checkbox>
                </div>
              );
            })}
          </div>
        ) : type === "min" ? (
          <Space style={{ width: '100%' }}>
            <NumberInput
              placeholder={placeholders?.from || "min"}
              value={from}
              onChange={(val) => onFromChange(String(val))}
              style={{ flex: 1 }}
            />
            <div style={{ flex: 1 }} />
          </Space>
        ) : (
          <Space style={{ width: '100%' }}>
            <NumberInput
              placeholder={placeholders?.from || "from"}
              value={from}
              onChange={(val) => onFromChange(String(val))}
              style={{ flex: 1 }}
            />
            <NumberInput
              placeholder={placeholders?.to || "to"}
              value={to}
              onChange={(val) => onToChange(String(val))}
              style={{ flex: 1 }}
            />
          </Space>
        )}
      </Col>
    </Row>
  );
};

export default FilterRow;
